import React from 'react';
import { connect } from "react-redux";

import ReactTooltip from 'react-tooltip';
import {GridContainer, GridItem} from '../../../../../Common/DesignSystem/Grid';
import { Heading6 } from '../../../../../Common/DesignSystem/Text';
import Button from '../../../../../Common/DesignSystem/Button';
import { Input } from '../../../../../Common/DesignSystem/Input';
import { useVehicleForm } from './hooks/useVehicleForm';

import { VehicleInfoCard } from './VehicleInfoCard';
import { VehicleSettingsCard } from './VehicleSettingsCard';
import { VehicleSpecsCard } from './VehicleSpecsCard';
import { VehicleIconsCard } from './VehicleIconsCard';

const VehicleForm = ({
	overlayRef, contentRef, fileInputRef, fileDropRef, specInputRef, specDropRef, inputRefs,

	vehicle,
	loadingVehicle,

	editingVehicle,
	closeForm,
	isCreatingVehicle,
	windowWidth,
	containerHeight,
	vehicle_oem_details,
	vehicle_options,

	history,
	match,
	settings,
	userSession,
}) => {
	const {
		vehicleForm,
		updateVehicleForm,
		setStarValue,
		formDetails,
		uploadImage,
		loadingImage,
		uploadSpecSheet,
		loadingSpec,
		specName,
		specThumbnail,
		specType,
		selectSpecType,
		setSpecSheet,
		vehicleOptions,
		vehicleOemDetails,
		updateSelect,
		submitNew,
		submitEdit,
		loadingSubmit,
		imageThumbnail,
		imageName,
	} = useVehicleForm(settings, match, history, editingVehicle, vehicle_oem_details, vehicle_options, true);

	if (!vehicleForm) return;

	return (
		<div className="main_overlay" id="add-or-edit-vehicle-main-overlay" style={{backgroundColor: 'white'}} ref={overlayRef} onScroll={()=> {
			ReactTooltip.rebuild();
		}}>
			<div style={{display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'flex-start', padding: '8px 4px'}}>
				<div style={{justifyContent: 'center', alignItems: 'flex-end', paddingLeft: 36, display: 'flex', flex: 1}}>
					<Heading6>
						{isCreatingVehicle ? "Add Vehicle" : "Edit Vehicle"}
					</Heading6>
				</div>
				<div className="overlay_header_close include-mobile" onClick={(e) => closeForm()} >
					&times;
				</div>
			</div>
			<div className="overlay_header" ref={contentRef}>
				<div className="overlay_header_info_container">
					<div style={{flexGrow: 1}}>
						<GridContainer justifyContent='space-evenly' spacing={3} direction={windowWidth <= 768 ? "column" : "row"}>
							<GridItem xs={windowWidth <= 768 ? 12 : 8} className="overlay_header_grid_item">

								<VehicleInfoCard {...{ vehicleForm, windowWidth, updateSelect, updateVehicleForm, inputRefs, isCreatingVehicle, fileInputRef, fileDropRef, uploadImage, loadingImage, imageThumbnail, imageName, editingVehicleImage: vehicle?.photoUrl }} />

								<VehicleSettingsCard {...{ vehicleForm, windowWidth, updateSelect, updateVehicleForm, inputRefs, isCreatingVehicle, formDetails, setStarValue }} />

								<div style={{marginTop: 16}}>
									<Input
										textarea
										name="description"
										label="Description"
										value={vehicleForm.description}
										onChange={updateVehicleForm}
										style={{minHeight: 88}}
									/>
									<Input
										textarea
										name="accessories"
										label="Accessories and Modifications"
										value={vehicleForm.accessories}
										onChange={updateVehicleForm}
										style={{minHeight: 88}}
									/>
								</div>

							</GridItem>
							<GridItem xs={windowWidth <= 768 ? 12 : 4} className="overlay_header_grid_item">
								<VehicleSpecsCard {...{ vehicleForm, updateVehicleForm, updateSelect, specType, selectSpecType, specName, specThumbnail, specInputRef, specDropRef, uploadSpecSheet, loadingSpec, vehicleOptions, vehicleOemDetails, editingVehicleSpecSheet: vehicle?.specSheetUrl, setSpecSheet }} />

								<VehicleIconsCard {...{ vehicleForm, vehicleOemDetails }} />
							</GridItem>
						</GridContainer>

						{/* <InventoryForm {...{ inventoryForm, updateInventoryForm, windowWidth, inputRefs }} /> */}
					</div>
				</div>
			</div>
			<div className={"ds-sticky-bottom-button-container" + (((containerHeight) < (window.innerHeight * 0.9)) ? " nonsticky" : "")}>
				<Button secondary label="Cancel" medium style={{width: 172, marginRight: 24}} onClick={(e) => closeForm()}/>
				<Button primary label={isCreatingVehicle ? "Add Vehicle" : "Save Changes"} disabled={loadingSubmit} medium style={{width: 172}} onClick={isCreatingVehicle ? submitNew : submitEdit}/>
			</div>
		</div>
	)
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    settings: store.settings,
    stakeholder: store.stakeholder
})

export default connect(mapStateToProps)(VehicleForm)
